var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"u-text-dark-5 u-pb-2p",on:{"click":_setup.openTab}},[_vm._v("\n    "+_vm._s(_vm._f("t")('Pages.ProductDetail.GetCutSheet.LinkText'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }